import { combineAiDataSources } from "../hooks/summarySnapshot.mjs";
import React, { useEffect, useState } from 'react';
import { useSummaryData } from '../hooks/useSummaryData';
import { ClassName_MONTHLY_ELECTRICITY_USAGE_COSTS, ClassName_MONTHLY_GAS_USAGE_COSTS } from './summaryChartClassnames';
import { UsageAndCostsBaseChart } from '@/components/base-chart/UsageAndCostsBaseChart/UsageAndCostsBaseChart';

export const config = {
  gas: {
    title: 'Monthly Gas Usage and Costs',
    name: 'Gas',
    color: '#c00000',
    unit: 'MMbtu'
  },
  electricity: {
    title: 'Monthly Electricity Usage and Costs',
    name: 'Electricity',
    color: '#4472c4',
    unit: 'kWh'
  }
}

export const ConsumptionAndCostsCharts = ({
  type,
  period,
  endingMonth,
  disableTooltip = false
}) => {

  const source = useSummaryData(type, period, endingMonth);
  const { data = { [type]: [] } } = source;
  const chartData = data[type]

  const classname = type === 'gas' ? ClassName_MONTHLY_GAS_USAGE_COSTS : ClassName_MONTHLY_ELECTRICITY_USAGE_COSTS;

  return (
    <UsageAndCostsBaseChart
      data={chartData}
      type={type}
      title={config[type].title}
      className={classname}
      style={{ width: '100%', height: '100%' }}
      customOptions={disableTooltip ? { tooltip: { show: false } } : {}}
      aiContext={{
        pageId: "page.facility.utility.summary",
          ...combineAiDataSources(source),
        chart: {
          chartId: `utility.${type}.usage_cost`,
          title: config[type].title,
          aliases: type === "electricity"
            ? ["electricity usage and cost", "monthly electricity chart", "月度电力用量和成本", "电力成本图"]
            : ["gas usage and cost", "monthly gas chart", "月度燃气用量和成本", "燃气成本图"],
          chartType: "bar_line",
          description: "Monthly utility usage shown as bars with monthly costs shown as a line.",
          filters: { period, ending_month: endingMonth },
          sourceOperationIds: ["utility.monthly_usage_cost"],
          series: [
            {
              name: "Usage",
              unit: config[type].unit,
              points: chartData.map((item) => ({ label: item.month, value: item.usage })),
            },
            {
              name: "Costs",
              unit: "USD",
              points: chartData.map((item) => ({ label: item.month, value: item.costs })),
            },
          ],
          completeness: chartData.length ? "complete" : "unknown",
        },
      }}
    />
  );
}
